import { render, staticRenderFns } from "./search-forms-order-confirmation.vue?vue&type=template&id=1a51a5e6&scoped=true&"
import script from "./search-forms-order-confirmation.vue?vue&type=script&lang=js&"
export * from "./search-forms-order-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./search-forms-order-confirmation.vue?vue&type=style&index=0&id=1a51a5e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a51a5e6",
  null
  
)

export default component.exports